<template>


    <div class="notification  mx-0 mx-md-4 error-message error-text w-50 w-sm-100 m-md-auto">

        <div  v-if="notification">
        <span  v-html="notification.msg"></span>
        <span v-if="notification.errorCode === 403 && saved_reSendCurrentTime"> in  {{saved_reSendCurrentTime}} seconds.</span>
        </div>
        <div v-else>
            <span  v-html="msg"></span>
        <span v-if="errorCode === 403 && saved_reSendCurrentTime"> in  {{saved_reSendCurrentTime}} seconds.</span>
        </div>
    </div>

</template>

<script>
    import UserUtils from './mixins/UserUtils';
    export default {
        mixins: [UserUtils],
        props: {
            notification: {
                type: Object,
                required: true
            },
            msg:String,
            errorCode: {
                type: Number,
                required: false
            }
        },
        
    }
</script>

<style scoped>
.desktop{
    width: 50%;
}
@media screen {
    
}
</style>
